import { FC } from 'react'
import { parseLocalISODate } from 'lib/date'
import { useTracking, track } from 'lib/analytics'
import { CrayonsConfettiIcon } from 'baby-ui/foundation/BabylistIcons/BabylistIcons'
import Slide, { Title } from '../../Slide/Slide'
import { NextButton } from '../../OnboardingButtons/OnboardingButtons'
import css from './Milestone.styles.scss'
import { urlWithChecklistParam } from 'utils'

interface MilestoneProps {
  arrivalDate?: string
  nextPath: string
}

const Milestone: FC<MilestoneProps> = ({ arrivalDate, nextPath }) => {
  const tracker = useTracking()
  const url = urlWithChecklistParam(nextPath)

  const kindergartenYear = (arrivalDate: Date) =>
    // avg kindergarten age requirement is age 5 *on or before* Sept 1
    // getMonth() starts at 0
    (arrivalDate.getMonth() === 8 && arrivalDate.getDate() === 1) ||
    arrivalDate.getMonth() < 8
      ? arrivalDate.getFullYear() + 5
      : arrivalDate.getFullYear() + 6

  return (
    <Slide>
      <div className={css.Milestone__headerContainer}>
        <CrayonsConfettiIcon />
        <div className={css.Milestone__textContainer}>
          <Title className={css.Milestone__title}>
            That means in{' '}
            {arrivalDate
              ? kindergartenYear(parseLocalISODate(arrivalDate))
              : '____'}
            ,
            <br />
            they'll be headed off to kindergarten.
          </Title>
          <p className={css.Milestone__subTitle}>They grow up so fast!</p>
        </div>
      </div>
      <NextButton
        onClick={() => {
          tracker.trackEvent({
            event: track.onboardingQuestionAnswered,
            eventLocation: track.EventLocation.ONBOARDING_MINUS_MILESTONE,
          })
        }}
        to={url}
      />
    </Slide>
  )
}

export default Milestone
